export const characters = [
  {
    id: 'char-001',
    name: '林知夏',
    role: '女主角 · 集团秘书',
    dramaId: 'tv-001',
    dramaTitle: '善良的女秘书',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20kind%20professional%20young%20Chinese%20woman%20in%20elegant%20office%20attire%2C%20warm%20soft%20light%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=char-001-avatar&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20office%20scene%20with%20a%20young%20professional%20woman%20standing%20by%20a%20large%20window%20at%20golden%20hour%2C%20deep%20red%20accent%20tones%2C%20minimal%20editorial%20background%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=char-001-cover&orientation=landscape',
    tagline: '她相信，善意从来不是软弱，而是一种需要勇气的选择。',
    intro: [
      '林知夏出身普通，大学毕业后靠自己的努力进入集团总部，成为总裁办公室的一名秘书。她没有显赫的背景，也没有过人的心机，唯一拥有的，是一份对工作的认真和对人的真诚。',
      '在复杂的人事关系中，她常常因为不愿随波逐流而被误解，但她从未因此改变自己。她学着在善意与边界之间找到平衡，也学着在坚持原则的同时保护好自己。',
      '随着剧情推进，她从一个略显青涩的新人，逐渐成长为能够独当一面的职场女性。这个过程中最动人的，是她始终没有丢掉最初的那份温柔。',
    ],
    traits: ['真诚善良', '外柔内刚', '认真细致', '共情力强'],
    relations: [
      { name: '沈砚清', relation: '上司 / 情感线' },
      { name: '周慕白', relation: '同事 / 携手同行' },
      { name: '苏念安', relation: '好友 / 知心闺蜜' },
      { name: '董事会元老', relation: '对立 / 理念冲突' },
    ],
    tabs: [
      {
        key: 'growth',
        label: '成长轨迹',
        content: [
          '初入职场：面对陌生环境手忙脚乱，常常加班到深夜，却从不抱怨。',
          '站稳脚跟：凭借一次关键项目的出色表现，获得团队认可。',
          '独当一面：在危机中挺身而出，成为总裁最信任的人之一。',
          '坚守初心：即便身处漩涡中心，依然选择以善意回应世界。',
        ],
      },
      {
        key: 'relation',
        label: '人物关系',
        content: [
          '与沈砚清：从上下级的疏离，到彼此理解的默契，情感在克制中生长。',
          '与周慕白：并肩作战的伙伴，也是她在迷茫时最可靠的支持。',
          '与苏念安：多年的好友，见证了她每一次的脆弱与坚强。',
          '与董事会：理念上的正面交锋，也推动了她真正的成长。',
        ],
      },
      {
        key: 'scene',
        label: '名场面',
        content: [
          '深夜办公室里那份被反复修改的方案，写满了她对工作的尊重。',
          '会议桌上替同事挡下的一句质问，成为剧集口碑爆棚的瞬间。',
          '天台上那句"我只是想做好我该做的事"，让无数观众破防。',
        ],
      },
    ],
  },
  {
    id: 'char-002',
    name: '沈砚清',
    role: '男主角 · 集团总裁',
    dramaId: 'tv-001',
    dramaTitle: '善良的女秘书',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20composed%20elegant%20Chinese%20businessman%20in%20a%20dark%20suit%2C%20warm%20soft%20light%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=char-002-avatar&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20executive%20office%20at%20dusk%20with%20a%20businessman%20looking%20out%20over%20a%20city%2C%20warm%20red%20accent%20light%2C%20minimal%20editorial%20background%2C%20cinematic%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=char-002-cover&orientation=landscape',
    tagline: '习惯了独自承担一切的人，最难学会的，是允许自己被人理解。',
    intro: [
      '沈砚清是集团最年轻的总裁，外表疏离，行事果断。在别人眼中，他冷静得近乎无情，但很少有人知道，这份冷静背后藏着怎样的过往。',
      '他对林知夏的欣赏，最初源于工作中的认可，后来渐渐变成了不愿承认的在意。他并不擅长表达情感，却总在关键时刻出现在她身边。',
      '随着剧情发展，他慢慢学会放下防备。这个角色的动人之处，在于他并非完美无缺的"霸总"，而是一个同样在学习如何去爱的普通人。',
    ],
    traits: ['沉稳克制', '外冷内热', '责任感强', '不善表达'],
    relations: [
      { name: '林知夏', relation: '下属 / 情感线' },
      { name: '周慕白', relation: '下属 / 亦师亦友' },
      { name: '父亲', relation: '未解的心结' },
    ],
    tabs: [
      {
        key: 'growth',
        label: '成长轨迹',
        content: [
          '接手集团：在质疑声中接下重担，用实力回应一切。',
          '遇见知夏：冰冷的世界里，第一次有人让他感到温暖。',
          '直面过往：与父亲之间多年的隔阂，终于有了和解的可能。',
        ],
      },
      {
        key: 'relation',
        label: '人物关系',
        content: [
          '与林知夏：从公事公办的上下级，到难以言说的在意。',
          '与周慕白：识于微时的信任，也是他最得力的伙伴。',
          '与父亲：疏远多年，彼此都在等待对方先开口。',
        ],
      },
      {
        key: 'scene',
        label: '名场面',
        content: [
          '雨夜里那辆停在楼下的车，是他不愿被看见的关心。',
          '"你不需要为所有人负责"，是他第一次卸下坚强的一刻。',
        ],
      },
    ],
  },
  {
    id: 'char-003',
    name: '苏念安',
    role: '女配角 · 知心好友',
    dramaId: 'tv-001',
    dramaTitle: '善良的女秘书',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20light%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=char-003-avatar&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20cafe%20scene%20with%20warm%20light%20and%20a%20cheerful%20young%20woman%20laughing%2C%20deep%20red%20accent%20tones%2C%20minimal%20editorial%20background%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=char-003-cover&orientation=landscape',
    tagline: '她像一束光，总能在朋友最黯淡的时候，递上一杯温水。',
    intro: [
      '苏念安是林知夏的大学同学，也是她最亲密的朋友。不同于知夏的谨慎，她性格爽朗、敢爱敢恨，是那种走到哪里都能带来笑声的人。',
      '她自己的人生也并非一帆风顺，但她习惯把笑容留给别人，把眼泪藏起来。正是这样的她，总能在知夏最需要的时候，成为那个稳稳的依靠。',
    ],
    traits: ['开朗爽直', '重情重义', '乐观坚韧'],
    relations: [
      { name: '林知夏', relation: '知心闺蜜' },
      { name: '周慕白', relation: '欢喜冤家' },
    ],
    tabs: [
      {
        key: 'growth',
        label: '成长轨迹',
        content: ['大学时代与知夏相识，成为彼此最重要的朋友。', '在感情中历经波折，最终学会先爱自己。'],
      },
      {
        key: 'relation',
        label: '人物关系',
        content: ['与林知夏：无话不谈的闺蜜，也是彼此的情绪出口。', '与周慕白：从互怼到心动，感情线轻松又好笑。'],
      },
      {
        key: 'scene',
        label: '名场面',
        content: ['知夏最难熬的那个夜晚，是她默默陪着坐到了天亮。'],
      },
    ],
  },
  {
    id: 'char-004',
    name: '高寒川',
    role: '男主角 · 刑警队长',
    dramaId: 'tv-007',
    dramaTitle: '暗夜追凶',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20determined%20male%20detective%20in%20a%20dark%20coat%2C%20moody%20warm%20red%20rim%20light%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=char-004-avatar&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20a%20detective%20silhouette%2C%20moody%20warm%20red%20accent%20light%2C%20minimal%20editorial%20background%2C%20cinematic%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=char-004-cover&orientation=landscape',
    tagline: '他追的从来不只是凶手，还有一个被时间掩埋的答案。',
    intro: [
      '高寒川是一名经验丰富的刑警队长。十年前的一桩悬案，是他心里始终无法愈合的伤口，也是支撑他坚持至今的理由。',
      '他沉默寡言，不轻易相信别人，却对自己的判断近乎固执。直到遇见法医林见鹿，他才渐渐学会在孤独的追凶路上，允许有个人并肩同行。',
    ],
    traits: ['坚韧执着', '冷静理性', '内心细腻'],
    relations: [
      { name: '林见鹿', relation: '搭档 / 信任' },
      { name: '马国栋', relation: '师父 / 引路人' },
    ],
    tabs: [
      {
        key: 'growth',
        label: '成长轨迹',
        content: ['十年前悬案成为心结，从此踏上追凶之路。', '与林见鹿相遇，学会信任与并肩。'],
      },
      {
        key: 'relation',
        label: '人物关系',
        content: ['与林见鹿：从磨合到默契，是最坚实的搭档。', '与马国栋：亦师亦友，也是他坚持的底气。'],
      },
      {
        key: 'scene',
        label: '名场面',
        content: ['真相揭晓的那一刻，他第一次在雨里红了眼眶。'],
      },
    ],
  },
  {
    id: 'char-005',
    name: '林见鹿',
    role: '女主角 · 法医',
    dramaId: 'tv-007',
    dramaTitle: '暗夜追凶',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20smart%20young%20Chinese%20female%20forensic%20scientist%20in%20white%20lab%20coat%2C%20cool%20soft%20light%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=char-005-avatar&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20forensic%20lab%20at%20night%20with%20blue%20cool%20light%20and%20red%20accent%2C%20minimal%20editorial%20background%2C%20cinematic%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=char-005-cover&orientation=landscape',
    tagline: '逝者无法开口，那她便替他们说出真相。',
    intro: [
      '林见鹿是一名出色的法医，专业、理性，面对再残忍的现场也能保持冷静。对她而言，每一具遗体都在讲述一个未完成的故事。',
      '她与高寒川的搭档关系始于一场并不愉快的合作，却在一次次并肩破案中慢慢磨合。她是他追凶路上最理性的一双眼睛。',
    ],
    traits: ['专业严谨', '理性冷静', '共情细腻'],
    relations: [
      { name: '高寒川', relation: '搭档 / 信任' },
      { name: '实验室团队', relation: '并肩作战' },
    ],
    tabs: [
      {
        key: 'growth',
        label: '成长轨迹',
        content: ['凭借过硬专业能力进入专案组。', '在一次次案件中理解真相的重量。'],
      },
      {
        key: 'relation',
        label: '人物关系',
        content: ['与高寒川：理性与执念的互补，也是最默契的搭档。'],
      },
      {
        key: 'scene',
        label: '名场面',
        content: ['她冷静说出结论时，镜头里所有人为之屏息的一刻。'],
      },
    ],
  },
];